import {
  MastercardIcon,
  DiscoverIcon,
  DinersIcon,
  VisaIcon,
  AmericanExpressIcon,
  AccountBalanceIcon,
} from '@clearcover/atlas';

export const paymentIcon = {
  mastercard: MastercardIcon,
  discover: DiscoverIcon,
  diners: DinersIcon,
  visa: VisaIcon,
  americanExpress: AmericanExpressIcon,
  bank: AccountBalanceIcon,
  other: AccountBalanceIcon,
} as const;
